import { Platform } from 'react-native';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class DiscoveryPathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { path } = this.context;
    // special handling of entry state for discovery on web
    if (Platform.OS === 'web' && path.startsWith('/discovery')) {
      const match = /\/discovery\/([^\/\s]+)/.exec(path);
      const categoryUrlCode = match?.[1];
      if (categoryUrlCode !== 'events' && categoryUrlCode !== 'category') {
        return {
          routes: [
            {
              name: 'home',
              params: {
                screen: 'discovery',
                params: {
                  categoryUrlCode,
                },
              },
            },
          ],
        };
      }
    }
  }
}
